import { ForemanEmployeeInOut } from './foreman-employee-in-out.model';

export interface ForemanEmployeeLabor {
  foremanEmployeeLaborID: string;
  foremanEmployeeJobID: string;
  foremanEarnCode: string;
  dateWorked: Date;
  shift: number;
  foremanJobCrewID: string;
  hours: number;
  foremanPhaseID: string;
  bActive: boolean;
  isAbsent: boolean;
  absentReasonID: string;
  absentReason: string;
  absentReasonOther: string;
  foremanNotes: string;
  isException?: boolean;
  foremanExceptionNotes?: string;
  isChanged: boolean;
  /** Server-owned UTC instant. The API wire value must include Z or an offset. */
  modifiedDate?: Date | string | null;
  /** Device draft edit time as Unix epoch milliseconds (timezone-independent). */
  localChangedAtUtcMs?: number;
  /** Device-only fingerprint of the last committed (server) values. */
  committedSignature?: string;
  inOuts: ForemanEmployeeInOut[];
}
